import { render } from "./PreparePacket.vue?vue&type=template&id=02f4a807&scoped=true"
import script from "./PreparePacket.vue?vue&type=script&lang=js"
export * from "./PreparePacket.vue?vue&type=script&lang=js"

import "./PreparePacket.vue?vue&type=style&index=0&id=02f4a807&scoped=true&lang=css"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f4a807"]])

export default __exports__